import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import cnb from 'classnames';
import styles from './programs.module.scss';

export function SampleReport({ data, title, className }) {
  return (
    <div
      className={cnb(styles.sampleReportWrapper, { [className]: className })}
    >
      <Container>
        <div className="heading">
          <h2 className="mb-0">{title ? title : 'Reports'}</h2>
        </div>
        <Row>
          {data.map((rdata, idx) => (
            <Col md="6" key={idx}>
              <div className={styles.reportList}>
                {!!rdata.title && <h3>{rdata.title}</h3>}
                <ul>
                  {rdata.items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
